import styled from "@emotion/styled";

import { Form, PAGE_SIDE_PADDING } from "@skilitics/designer-ui-components";

export const LayoutGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${PAGE_SIDE_PADDING / 2}px;
  gap: ${PAGE_SIDE_PADDING / 2}px;
`;

export const LayoutForm = styled(Form)<{ $gridColumns: string }>`
  border: none;
  display: grid;
  grid: auto / ${({ $gridColumns }) => $gridColumns};
  gap: ${PAGE_SIDE_PADDING / 2}px;

  &.added {
    @starting-style {
      opacity: 0;
    }

    transition: opacity 0.5s;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
  height: 44px;
`;

// FormRow without width 100% because we're using grid layout
export const FormCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
